import axios from "axios";
import router from "@/router";
import { ElMessage, ElMessageBox } from 'element-plus'
import { logout } from "@/request/api/user/index";
import { resetRouter } from "@/utils/routeUtil.js";
import { removeLoginStatus } from "@/utils/commons.js";


let isRelogin = { show: false };
const axiosInstance = axios.create({
  // VUE_APP_BASE_API = '/backenapi'
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // 设置跨域
  timeout: 60000 * 2 // 设置10秒超时时间
  //timeout: 10000 // 设置10秒超时时间
});

// 请求拦截
axiosInstance.interceptors.request.use(request => {
  // 是否需要设置 token
  const isToken = request.headers.isToken
  if (isToken !== false) {
    request.headers['x-token'] = localStorage.getItem('token')
  }
  return request;
}, error => {
  return error;
});

// 响应拦截
axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    /* 网络连接失败自动处理 */
    if (error.message.indexOf("Network Error") !== -1) {
      ElMessage.error("无法连接服务器!");
      return Promise.reject(error);
    }
    /* 网络请求超时自动处理 */
    if (error.message.indexOf("timeout") !== -1) {
      ElMessage.error("服务器请求超时!");
      return Promise.reject(error);
    }
    /* 请求400处理 */
    if (error.response.status === 400) {
      ElMessage.error("请求不合法!");
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;

        try {
          await ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
          )
          isRelogin.show = false;
          await logout()
          removeLoginStatus()
          resetRouter()
          router.replace({ path: '/login' })

        } catch (error) {
          isRelogin.show = false;
        }
      }

      return Promise.reject(error);
    }
    if (error.response.status === 403) {
      ElMessage.error("当前操作没有权限!");
      return Promise.reject(error);
    }
    /* 请求404处理 */
    if (error.response.status === 404) {
      ElMessage.error("请求接口不存在!");
      return Promise.reject(error);
    }
    if (error.response.status === 415) {
      ElMessage.error("请求415!");
      return Promise.reject(error);
    }
    // 响应500处理
    if (error.response.status === 500) {
      ElMessage.error("服务器内部错误!");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  });

export default axiosInstance;
